import type { RagAskLabels } from '../config/rag-ask.config';
import type { AskSource, Freshness } from '../models/ask.models';

export interface FreshnessBadge {
  readonly label: string;
  readonly icon: 'check' | 'alert' | 'help';
  readonly modifier: string;
}

/**
 * Freshness is always icon + text, never colour alone (accessibility: colour
 * must not be the sole carrier of meaning).
 */
export function freshnessBadge(freshness: Freshness, labels: RagAskLabels): FreshnessBadge {
  switch (freshness) {
    case 'fresh':
      return { label: labels.freshnessFresh, icon: 'check', modifier: 'rag-badge--fresh' };
    case 'stale':
      return { label: labels.freshnessStale, icon: 'alert', modifier: 'rag-badge--stale' };
    default:
      return { label: labels.freshnessUnknown, icon: 'help', modifier: 'rag-badge--unknown' };
  }
}

/** `date_updated` wins, falling back to `date_created`. */
export function referenceDate(src: AskSource): string | null {
  return src.date_updated ?? src.date_created ?? null;
}

export function referenceDateLabel(src: AskSource, labels: RagAskLabels): string {
  return src.date_updated ? labels.updatedOn : labels.createdOn;
}

export function formatScore(score: number): number {
  return Math.round(score ?? 0);
}

export function scoreColor(score: number): string {
  const value = formatScore(score);
  if (value >= 80) return 'var(--rag-success)';
  if (value >= 60) return 'var(--rag-warning)';
  return 'var(--rag-text-tertiary)';
}
